import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MixpanelActionSource } from "helpers/services/mixpanel/events";
import { IStripeInvoiceOrUpcomingInvoice } from "helpers/stripe";
import { Filters } from "./search";
export enum PremiumFeatureSecondaryButton {
  CREATE_NEW_THREAD = "CREATE_NEW_THREAD",
  ADD_INTERACTION_TO_THREAD = "ADD_INTERACTION_TO_THREAD",
}

export type PremiumFeatureSecondaryButtonState =
  | {
      button: PremiumFeatureSecondaryButton.CREATE_NEW_THREAD;
      userMessage: string;
    }
  | {
      button: PremiumFeatureSecondaryButton.ADD_INTERACTION_TO_THREAD;
      threadId: string;
      userMessage: string;
      filters: Filters;
    };

// TODO(Jimmy): Port the rest of SubscriptionState to the useSubscription hook instead of the store
export interface SubscriptionState {
  upcomingInvoice: IStripeInvoiceOrUpcomingInvoice | null;
  upgradeToPremiumModalFeature?: CreditedFeature;
  disableProToggleOnPremiumModalClose?: boolean;
  premiumFeatureSecondaryButton?: PremiumFeatureSecondaryButtonState | null;
  actionSource: MixpanelActionSource | null;
}

export enum CreditedFeature {
  ASK_PAPER = "ASK_PAPER",
  STUDY_SNAPSHOT = "STUDY_SNAPSHOT",
  CONSENSUS_SNAPSHOT = "CONSENSUS_SNAPSHOT",
  QUICK_SEARCH = "QUICK_SEARCH",
  PRO_SEARCH = "PRO_SEARCH",
  DEEP_SEARCH = "DEEP_SEARCH",
  TABLE_EXTRACTION = "TABLE_EXTRACTION",
}

export const initialState: SubscriptionState = {
  subscription: { user: null, org: null },
  isSubscriptionLoaded: false,
  upgradeToPremiumModalFeature: undefined,
  upcomingInvoice: null,
  premiumFeatureSecondaryButton: null,
  actionSource: null,
} as SubscriptionState;

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setPremiumModalFeature(
      state: SubscriptionState,
      { payload }: PayloadAction<CreditedFeature>
    ) {
      state.upgradeToPremiumModalFeature = payload;
    },
    setActionSource(
      state: SubscriptionState,
      { payload }: PayloadAction<MixpanelActionSource | null>
    ) {
      state.actionSource = payload;
    },
    setUpcomingInvoice(state: SubscriptionState, { payload }) {
      state.upcomingInvoice = payload;
    },
    setDisableProToggleOnPremiumModalClose(
      state: SubscriptionState,
      { payload }: PayloadAction<boolean>
    ) {
      state.disableProToggleOnPremiumModalClose = payload;
    },
    setPremiumFeatureSecondaryButton(
      state: SubscriptionState,
      { payload }: PayloadAction<PremiumFeatureSecondaryButtonState | null>
    ) {
      state.premiumFeatureSecondaryButton = payload;
    },
  },
});

export const {
  setPremiumModalFeature,
  setUpcomingInvoice,
  setDisableProToggleOnPremiumModalClose,
  setPremiumFeatureSecondaryButton,
  setActionSource,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
